/**
 * Decode html string
 * @param {string} html - HTML string
 * @return {string} Decoded string
 */
function decodeHtml(html) {
	var txt = document.createElement("textarea");
	txt.innerHTML = html;
	return txt.value;
}

/**
 * Swatches selector component
 *
 * @todo Change this component to swatchSelector.
 * @module swatches-selector
 * @version 1.0.0
 * @extends HTMLElement
 */
class swatchComponentNew extends HTMLElement {
	
	/**
	 * Product swatch selector web component.
	 *
	 * @constructor
	 */
	constructor() {
		super();

		window.theme.product
			.loadProduct(this.dataset.handle, true)
			.then((product) => {
				this.render(product);
			});
	}

	/**
	 * Render component in the DOM
	 *
	 * @param {object} product Product data.
	 * @returns {undefined}
	 */
	render(product) {
		
		let html = this.getTemplate(),
			content = "";
			

		if (html && !this.querySelector("[data-option]")) {
			if (product.options.length > 0 && product.options[0].values.length > 1) {
				product.options.forEach((option, index) => {
					let position = index + 1;

					content =
						content +
						`<div class="swatches__swatch" data-option="${option.name.replaceAll(
							" ",
							"-"
						)}" data-position="${position}">`;
					content =
						content +
						`<div class="swatches__swatch-label">${option.name}:</div>`;

					content =
						content +
						`<div class="swatches__swatch-image"><div class="swatches__swatch-loading swatches__swatch-loading--image loading">loading</div></div>`;

					content = content + `</div>`;
				});

				this.innerHTML = content;
			}
		}

		this.loadSwatches(product);

		this.selectFirstVariantAvailable(product);

		this.initEvents(product);
	}

	/**
	 * Get component template
	 *
	 * @returns {string} Component HTML template.
	 */
	getTemplate() {
		return window.theme.swatchSelector.template
			? window.theme.swatchSelector.template
			: "";
	}

	/**
	 * Init component events.
	 *
	 * @param {object} product Product data.
	 * @returns {undefined}
	 */
	initEvents(product) {
		// On swatch change - Input
		this.querySelectorAll("[data-swatch-input]").forEach((element) => {
			element.addEventListener("change", (event) => {
				// console.log("First:", event.target, product);
				this.onSwatchChange(event.target, product);
			});
		});

		// On swatch change - Select Option
		this.querySelectorAll("[data-select]").forEach((element) => {
			element.addEventListener("change", (event) => {
				// console.log(
				//   "Second:",
				//   event.target.options[event.target.selectedIndex],
				//   product
				// );
				this.onSwatchChange(
					event.target.options[event.target.selectedIndex],
					product
				);
			});
		});

		// On variant selector ready
		let variantSelector = document.querySelector(
			'variant-selector[data-handle="' + this.dataset.handle + '"]'
		);

		variantSelector.addEventListener("ready", (event) => {
			variantSelector
				.querySelector("select")
				.addEventListener("change", (event) => {
					this.updateSwatchValues();
					this.disableOutOfStockVariants();
				});

			this.selectFirstVariantAvailable(product);
			// console.log("varints selector Ready");
		});

		// After variant selector ready event
		if (variantSelector.classList.contains("ready")) {
			variantSelector
				.querySelector("select")
				.addEventListener("change", (event) => {
					this.updateSwatchValues();
					this.disableOutOfStockVariants();
				});

			this.selectFirstVariantAvailable(product);
		}
	}

	/**
	 * Load swatch inputs from a product
	 *
	 * @param {object} product Product data.
	 * @returns {undefined|boolean}
	 */
	loadSwatches(product) {
		if (!window.theme.product.hasVariants(product)) return false;

		product.options.forEach((option) => {
			if (this.getImageSwatchOptions().includes(option.name.toUpperCase())) {
				// this.loadSwatchImage(option, product);
				this.loadSwatchTextRadio(option, product);
			} else {
				this.loadSwatchText(option, product);
			}
		});
	}

	/**
	 * Get array of the custom option to be used as an image swatch.
	 *
	 * @returns {Array} Array of the custom options.
	 */
	getImageSwatchOptions() {
		if (typeof this.imageSwatchOptions == "undefined") {
			this.imageSwatchOptions = window.theme.swatchSelector.imageTypes
				.toUpperCase()
				.split("|");

			return this.imageSwatchOptions;
		} else {
			return this.imageSwatchOptions;
		}
	}

	/**
	 * Get swatch element from DOM.
	 *
	 * @returns {object} Swatch element.
	 */
	getSwatchElement(optionName) {
		return this.querySelector(
			'[data-option="' + optionName.replaceAll(" ", "-") + '"]'
		);
	}

	/**
	 * Render swatch as an image.
	 *
	 * @param {object} product Product data.
	 * @param {object} option Product option data.
	 * @returns {undefined|boolean}
	 */
	loadSwatchImage(option, product) {
		let element = this.getSwatchElement(option.name),
			swatches = window.theme.swatches.getSwatches(product, option.name),
			label = this.getSwatchLabelTemplate(),
			finalHtml = "";

		element.classList.add("swatches__swatch--image");
		element.classList.add(
			"swatches__swatch--image-" + option.name.replaceAll(" ", "-")
		);

		label = label.replaceAll("{{ option_name }}", option.name);

		option.values.forEach((value) => {
			let html = this.getSwatchImageTemplate(),
				image = swatches.find((item) => {
					return item.value == value;
				}),
				id =
					"option-" +
					option.name.toLowerCase().replaceAll(" ", "-") +
					"-" +
					value.toLowerCase().replaceAll(" ", "-").replaceAll("/","-");

			if (!image.src) return false;

			html = html.replaceAll("{{ value }}", value);
			html = html.replaceAll("{{ name }}", option.name);
			html = html.replaceAll("{{ id }}", id);
			html = html.replaceAll("{{ src }}", image.src);

			finalHtml = finalHtml + html;
		});

		element.innerHTML = label + finalHtml;
	}

	/**
	 * Render swatch as a text.
	 *
	 * @todo Merge this function with loadSwatchImage.
	 * @param {object} product Product data.
	 * @param {object} option Product option data.
	 * @returns {undefined|boolean}
	 */
	loadSwatchText(option, product) {
		let element = this.getSwatchElement(option.name.replaceAll(" ", "-")),
			label = this.getSwatchLabelTemplate(),
			finalHtml = "";

		if (element) {
			let additionalClass = option.values.length == 0 ? "hidden" : "";
			element.classList.add("swatches__swatch--text");
			element.classList.add(
				"swatches__swatch--text-" +
					option.name.replaceAll(" ", "-").toLowerCase()
			);

			label = label.replaceAll("{{ option_name }}", option.name);
			let variantIds = [];
			product.variants.forEach((varint) => {
				variantIds.push(varint.id);
			});

			option.values.forEach((value, index) => {
				let html = this.getSwatchTextTemplate(),
					id =
						"option-" +
						option.name.toLowerCase().replaceAll(" ", "-") +
						"-" +
						value.toLowerCase().replaceAll(" ", "-").replaceAll("/","-");

				html = html.replaceAll("{{ value }}", value);
				html = html.replaceAll("{{ name }}", option.name.replaceAll(" ", "-"));
				html = html.replaceAll("{{ id }}", id.replaceAll('"', ""));
				html = html.replaceAll("{{ additionalClass }}", additionalClass);
				html = html.replaceAll("{{ varint.id }}", variantIds[index]);

				finalHtml = finalHtml + html;
			});

			finalHtml =
				finalHtml +
				'<select data-select class="swatches__swatch-select" name="' +
				option.name.replaceAll(" ", "-") +
				'" id="select-' +
				option.name.toLowerCase().replaceAll(" ", "-") +
				'">';

			option.values.forEach((value, index) => {
				let html = this.getSwatchTextSelectTemplate(),
					id =
						"option-" +
						option.name.toLowerCase().replaceAll(" ", "-") +
						"-" +
						value.toLowerCase().replaceAll(" ", "-");

				html = html.replaceAll("{{ value }}", value);
				html = html.replaceAll("{{ name }}", option.name.replaceAll(" ", "-"));
				html = html.replaceAll("{{ id }}", id.replaceAll('"', ""));
				html = html.replaceAll("{{ additionalClass }}", additionalClass);
				html = html.replaceAll("{{ varint.id }}", variantIds[index]);

				finalHtml = finalHtml + html;
			});

			finalHtml = finalHtml + "</select>";

			element.innerHTML = label + finalHtml;
		}
	}

	/**
	 * Render swatch as a Radio.
	 *
	 * @todo Merge this function with loadSwatchImage.
	 * @param {object} product Product data.
	 * @param {object} option Product option data.
	 * @returns {undefined|boolean}
	 */
	loadSwatchTextRadio(option, product) {
		let element = this.getSwatchElement(option.name.replaceAll(" ", "-")),
			label = this.getSwatchLabelTemplate(),
			finalHtml = "";

		if (element) {
			let additionalClass = option.values.length == 0 ? "hidden" : "";
			element.classList.add("swatches__swatch--radio");
			element.classList.add(
				"swatches__swatch--radio-" +
					option.name.replaceAll(" ", "-").toLowerCase()
			);

			label = label.replaceAll("{{ option_name }}", option.name);
			let variantIds = [];
			product.variants.forEach((varint) => {
				variantIds.push(varint.id);
			});

			option.values.forEach((value, index) => {
				let html = this.getSwatchTextRadioTemplate(),
					id =
						"option-" +
						option.name.toLowerCase().replaceAll(" ", "-").replaceAll("/", "-") +
						"-" +
						value.toLowerCase().replaceAll(" ", "-").replaceAll("/", "-");

				html = html.replaceAll("{{ value }}", value);
				html = html.replaceAll("{{ name }}", option.name.replaceAll(" ", "-"));
				html = html.replaceAll("{{ id }}", id.replaceAll('"', ""));
				html = html.replaceAll("{{ additionalClass }}", additionalClass);
				html = html.replaceAll("{{ varint.id }}", variantIds[index]);

				finalHtml = finalHtml + html;
			});

			finalHtml =
				finalHtml +
				'<select data-select class="swatches__swatch-select" name="' +
				option.name.replaceAll(" ", "-") +
				'" id="select-' +
				option.name.toLowerCase().replaceAll(" ", "-") +
				'">';

			option.values.forEach((value, index) => {
				let html = this.getSwatchTextSelectTemplate(),
					id =
						"option-" +
						option.name.toLowerCase().replaceAll(" ", "-") +
						"-" +
						value.toLowerCase().replaceAll(" ", "-");

				html = html.replaceAll("{{ value }}", value);
				html = html.replaceAll("{{ name }}", option.name.replaceAll(" ", "-"));
				html = html.replaceAll("{{ id }}", id.replaceAll('"', ""));
				html = html.replaceAll("{{ additionalClass }}", additionalClass);
				html = html.replaceAll("{{ varint.id }}", variantIds[index]);

				finalHtml = finalHtml + html;
			});

			finalHtml = finalHtml + "</select>";

			element.innerHTML = label + finalHtml;
		}
	}

	/**
	 * Get swatch label html template.
	 *
	 * @todo Move this template to a liquid file.
	 * @returns {string} HTML template.
	 */
	getSwatchLabelTemplate() {
		return '<div class="swatches__swatch-label">Select <span class="swatches__swatch-title">{{ option_name }}</span>: <strong data-swatch-label="{{ option_name }}"></strong></div>';
	}

	/**
	 * Get swatch image html template.
	 *
	 * @todo Move this template to a liquid file.
	 * @returns {string} HTML template.
	 */
	getSwatchImageTemplate() {
		return `<div class="image-swatches__swatch">
                    <input variant-id="{{ varint.id }}" type="radio" id="{{ id }}" name="{{ name }}" value='{{ value }}' aria-label="{{ value }}" data-swatch-input="{{ name }}">
                    <label for="{{ id }}">{{ value }}</label> 
                    <img src="{{ src }}" alt="{{ value }}"/>  
                </div>`;
	}

	/**
	 * Get swatch text html template.
	 *
	 * @todo Move this template to a liquid file.
	 * @returns {string} HTML template.
	 */
	getSwatchTextTemplate() {
		return `<div class="image-swatches__swatch {{ additionalClass }} text-swatch">
                    <input variant-id="{{ varint.id }}" type="radio" id="{{ id }}" name="{{ name }}" value='{{ value }}' aria-label="{{ value }}" data-swatch-input="{{ name }}"> 
                    <label for="{{ id }}">{{ value }}</label>
                </div>`;
	}

	/**
	 * Get swatch text html template.
	 *
	 * @todo Move this template to a liquid file.
	 * @returns {string} HTML template.
	 */
	getSwatchTextRadioTemplate() {
		// return `<div class="image-swatches__swatch {{ additionalClass }} radio-swatch">
		return `<div class="radial-swatches__swatch  {{ additionalClass }} radio-swatch">
                    <input variant-id="{{ varint.id }}" type="radio" id="{{ id }}" name="{{ name }}" value='{{ value }}' aria-label="{{ value }}" data-swatch-input="{{ name }}"> 
                    <label for="{{ id }}"><span>{{ value }}</span></label>
                </div>`;
	}
	/**
	 * Get swatch text html select template.
	 *
	 * @todo Move this template to a liquid file.
	 * @returns {string} HTML template.
	 */
	getSwatchTextSelectTemplate() {
		return `<option id="{{ id }}" data-name="{{ name }}" value='{{ value }}' aria-label='{{ value }}' data-swatch-input="{{ name }}">{{ value }}</option>`;
	}

	/**
	 * On swatch change.
	 *
	 * @param {object} swatchInput Swatch input dom element.
	 * @param {object} product Product data.
	 * @returns {undefined}
	 */
	// onSwatchChange(swatchInput, product) {
	//   let variant = null;
	//   if (swatchInput.name) {
	//     //Inputs
	//     console.log("Swatch name:", swatchInput.name);

	//     this.updateOptionLabel(swatchInput);
	//     variant = this.getSelectedVariant(product, 1);
	//   } else {
	//     //Options
	//     console.log("No swatch name name", swatchInput);
	//     this.updateOptionLabel(swatchInput, true);
	//     variant = this.getSelectedVariant(product, 2);
	//   }
	//   console.log("Variant resuls:", variant);
	//   this.updateVariantSelector(variant);
	// }

	// added the below to keep swatches and dropdowns linked

	onSwatchChange(swatchInput, product) {
		let variant = null;

		if (swatchInput.name) {
			// This is a radio input
			// Sync the dropdown
			let correspondingDropdown = this.querySelector(
				`[data-select][name='${swatchInput.name}']`
			);
			if (correspondingDropdown) {
				correspondingDropdown.value = swatchInput.value;
			}

			this.updateOptionLabel(swatchInput);
			variant = this.getSelectedVariant(product, 1);
		} else {
			// This is a dropdown
			// Sync the radio input
			let optionName =
				swatchInput.dataset.name || swatchInput.parentElement.dataset.name;
			let correspondingRadio = this.querySelector(
				`[data-swatch-input='${optionName}'][value='${swatchInput.value}']`
			);
			if (correspondingRadio) {
				correspondingRadio.checked = true;
			}

			this.updateOptionLabel(swatchInput, true);
			variant = this.getSelectedVariant(product, 2);
		}

		// console.log("Variant results:", variant);
		this.updateVariantSelector(variant);
	}

	/**
	 * Get selected variant from swatch inputs.
	 *
	 * @param {object} product Product data.
	 * @param {number} type Type of input/option.
	 * @returns {object} Product variant data.
	 */
	getSelectedVariant(product, type) {
		// console.log(
		//   "getSelectedVariant function called with product and type:",
		//   product,
		//   type
		// );

		// Create object with selected options
		let selectedOptions = {};

		// Save the selected options in to the object
		this.querySelectorAll("[data-option]").forEach((element) => {
			// console.log("Processing element:", element);

			let input = null;

			if (element.querySelectorAll("[data-select]").length == 0 || type == 1) {
				// Inputs
				// console.log("Found Inputs.");

				input = element.querySelector("[data-swatch-input]:checked");
			} else {
				// Options
				// console.log("Found Options.");

				element.querySelectorAll("[data-select]").forEach((select) => {
					// console.log("Processing select:", select);

					if (select.options[select.selectedIndex]) {
						input = select.options[select.selectedIndex];
					} else {
						input = select.querySelector("[data-swatch-input]:checked");
					}
				});
			}

			if (input) {
				selectedOptions["option" + element.dataset.position] = input.value;
				// console.log("Added to selectedOptions:", {
				//   ["option" + element.dataset.position]: input.value,
				// });
			}
		});
		// console.log("Final selectedOptions:", selectedOptions);

		// Find a product variant based on the selected options
		return product.variants.find((item) => {
			// console.log("Checking item:", item);

			if (item.options.length == 1) {
				// console.log("Item has 1 option. Checking option1:", item.option1);
				return item.option1 == selectedOptions.option1;
			} else {
				let option2 = item.option2;
				let valueInput = selectedOptions.option2;

				// console.log(
				//   "Item has more than 1 option. Checking option1, option2:",
				//   item.option1,
				//   option2
				// );

				if (item.option3) {
					let option3 = item.option3;
					let valueInput3 = selectedOptions.option3;

					// console.log("Item has 3 options. Checking option3:", option3);

					return (
						item.option1 == selectedOptions.option1 &&
						option2 == valueInput &&
						option3 == valueInput3
					);
				} else {
					return (
						item.option1 == selectedOptions.option1 && option2 == valueInput
					);
				}
			}
		});
	}

	/**
	 * Update variant selector web component.
	 *
	 * @param {object} variant Product variant data.
	 * @returns {undefined}
	 */

	updateVariantSelector(variant) {
		let variantSelector = document.querySelector(
			'variant-selector[data-handle="' + this.dataset.handle + '"] select'
		);

		if (variantSelector) {
			variantSelector.value = variant ? variant.id : "";

			variantSelector.dispatchEvent(new Event("change"));

			let currentUrl = new URL(window.location.href);
			let searchParams = currentUrl.searchParams;

			// Update or append the variant parameter
			searchParams.set("variant", variant.id);

			// Modify the current URL with the updated search params
			currentUrl.search = searchParams.toString();

			window.history.replaceState({}, "", currentUrl.toString());
		}
	}

	/**
	 * Get variant selector web component.
	 *
	 * @returns {object} Variant selector web component from DOM.
	 */
	getVariantSelector() {
		return document.querySelector(
			'variant-selector[data-handle="' + this.dataset.handle + '"] select'
		);
	}

	/**
	 * Update swatch option label with the current selected value.
	 *
	 * @param {object} input Swatch input.
	 * @returns {undefined}
	 * Appends the actual width message if item is rod
	 * Built by Jay@strongerEcommerce
	 */
	updateOptionLabel(input, optionEl = false) {
		let name = "";
		let valueInput = input.value;
		let productHandle = this.dataset.handle;
		// let variantId = this.dataset.variantId + "b";
		let isWidth = false;
		let isRod = "vista-oval-rod";
		let isWirePullOut = "chrome-wire-pullout-drawer-new";
		let shelfPullOut = "shelf-pull-outs-2-pack";
		let pantsRack = "pants-rack-pull-out";
		let pullOutHamper = "chrome-pull-out-hamper-drawer";

		if (optionEl) {
			name = input.dataset.name.replaceAll("-", " ");
		} else {
			name = input.name.replaceAll("-", " ");
		}

		if (
			productHandle === isRod ||
			productHandle === isWirePullOut ||
			productHandle === shelfPullOut ||
			productHandle === pantsRack ||
			productHandle === pullOutHamper
		) {
			if (name === "Width" || name === "Size") {
				isWidth = true;
			}
		}

		let regex = /[\d|,|.|e|E|\+]+/g;
		let numbers = valueInput.match(regex) - 1.5;

		if (!name) name = input.dataset.name;
		if (isWidth) {
			this.querySelector('[data-swatch-label="' + name + '"]').innerHTML =
				valueInput +
				"\xa0<small>(actual " +
				name.toLowerCase() +
				"\xa0" +
				numbers +
				"”)</small>";
			// window.history.replaceState({ }, '', `${productHandle}?variant=${variantId}`);
		} else {
			this.querySelector('[data-swatch-label="' + name + '"]').innerHTML =
				valueInput;
		}
	}

	/**
	 * Select the first variant available from a product in the variant selector component.
	 *
	 * @param {object} product Product data.
	 * @returns {undefined}
	 */

	selectFirstVariantAvailable(product) {
		let url = new URL(window.location.href);
		let variantIdFromUrl = parseInt(url.searchParams.get("variant"));

		if (variantIdFromUrl) {
			let variant = product.variants.find((v) => v.id === variantIdFromUrl);
			this.selectVariant(variant);
			this.selectWidthOption(variant.title);
		} else {
			// Original code
			let firstAvailableOption = document.querySelector(
				'variant-selector[data-handle="' +
					this.dataset.handle +
					'"] option[data-enabled]'
			);
			if (firstAvailableOption) {
				let variant = product.variants.find((item) => {
					return item.id == firstAvailableOption.dataset.variantId;
				});
				this.selectVariant(variant);
			}
		}
	}

	/**
	 * Select variant from a product in the variant selector component.
	 *
	 * @todo Try to improve this code to reduce the code quantity.
	 * @param {object} variant Product variant data.
	 * @returns {undefined}
	 */
	// selectVariant(variant) {
	//   if (variant) {
	//     // let inputOption1 = this.querySelector(
	//     //   `[data-option][data-position='1'] input[value='` +
	//     //     variant.option1.replace(" ", "-") +
	//     //     `']`
	//     // );
	//     let inputOption1 = this.querySelector(
	//       `[data-option][data-position='1'] input[value='${decodeHtml(
	//         variant.option1
	//       )}']`
	//     );

	//     if (variant) {
	//       if (variant.option1) {
	//         // let inputOption1 = this.querySelector(
	//         //   `[data-option][data-position='1'] input[value='` +
	//         //     variant.option1.replace(" ", "-") +
	//         //     `']`
	//         // );
	//         let inputOption1 = this.querySelector(
	//           `[data-option][data-position='1'] input[value='${decodeHtml(
	//             variant.option1
	//           )}']`
	//         );

	//         if (inputOption1) {
	//           inputOption1.checked = true;
	//           this.updateOptionLabel(inputOption1);
	//         }
	//       }
	//       if (variant.option2) {
	//         let option2 = variant.option2;
	//         if (variant.option2) {
	//           option2 = variant.option2;
	//         }
	//         if (variant.option2) {
	//           option2 = variant.option2;
	//         }
	//         // let inputOption2 = this.querySelector(
	//         //   `[data-option][data-position="2"] input[value='` + option2 + `']`
	//         // );
	//         let inputOption2 = this.querySelector(
	//           `[data-option][data-position='2'] input[value='${decodeHtml(
	//             variant.option2
	//           )}']`
	//         );
	//         if (inputOption2) {
	//           inputOption2.checked = true;
	//           this.updateOptionLabel(inputOption2);
	//         }
	//       }

	//       if (variant.option3) {
	//         let option3 = variant.option3;
	//         if (variant.option3) {
	//           option3 = variant.option3;
	//         }
	//         if (variant.option3) {
	//           option3 = variant.option3;
	//         }
	//         // let inputOption3 = this.querySelector(
	//         //   `[data-option][data-position='3'] input[value='` + option3 + `']`
	//         // );
	//         let inputOption3 = this.querySelector(
	//           `[data-option][data-position='3'] input[value='${decodeHtml(
	//             variant.option3
	//           )}']`
	//         );
	//         if (inputOption3) {
	//           inputOption3.checked = true;
	//           this.updateOptionLabel(inputOption3);
	//         }
	//       }
	//     }
	//   }
	// }

	selectVariant(variant) {
		if (variant) {
			for (let i = 1; i <= variant.options.length; i++) {
				// Get the option value
				let optionValue = variant["option" + i];

				// Use decodeHtml to ensure we're matching against the correct value
				let decodedOptionValue = decodeHtml(optionValue);

				// Get the input element (swatch) for this option
				let inputElement = this.querySelector(
					`[data-option][data-position='${i}'] input[value='${decodedOptionValue}']`
				);

				// If the input element is found, select it
				if (inputElement) {
					inputElement.checked = true;
					this.updateOptionLabel(inputElement);
				}

				// Sync the dropdown based on the swatch selection
				let correspondingDropdown = this.querySelector(
					`[data-select][name='${inputElement.name}']`
				);

				if (correspondingDropdown) {
					correspondingDropdown.value = decodedOptionValue;
				}
			}
		}
	}

	// /**
	//  * Disable out of stock variant swatches.
	//  *
	//  * @returns {undefined}
	//  */
	// disableOutOfStockVariants() {
	//   let firstSelectedOption = {},
	//     secondSelectedOption = {},
	//     variantSelector = this.getVariantSelector();

	//   this.querySelectorAll("[data-option]").forEach((element) => {
	//     element.querySelectorAll("[data-swatch-input]").forEach((input) => {
	//       let selector = "",
	//         inputValue = input.value.replaceAll(" ", "-"),
	//         inputName = "";

	//       if (input.name) {
	//         inputName = input.name.replaceAll(" ", "-");
	//       } else {
	//         inputName = input.dataset.name.replaceAll(" ", "-");
	//       }

	//       switch (element.dataset.position) {
	//         case "1":
	//           selector =
	//             `[data-swatches-option-` +
	//             inputName +
	//             `='` +
	//             inputValue +
	//             `'][data-enabled]`;

	//           if (input.checked) {
	//             firstSelectedOption.name = inputName;
	//             firstSelectedOption.value = inputValue;
	//           }

	//           break;

	//         case "2":
	//           selector =
	//             `[data-swatches-option-` +
	//             firstSelectedOption.name +
	//             `='` +
	//             firstSelectedOption.value +
	//             `'][data-swatches-option-` +
	//             inputName +
	//             `='` +
	//             inputValue +
	//             `'][data-enabled]`;

	//           if (input.checked) {
	//             secondSelectedOption.name = inputName;
	//             secondSelectedOption.value = inputValue;
	//           }

	//           break;

	//         default:
	//           selector =
	//             `[data-swatches-option-` +
	//             firstSelectedOption.name +
	//             `='` +
	//             firstSelectedOption.value +
	//             `'][data-swatches-option-` +
	//             secondSelectedOption.name +
	//             `='` +
	//             secondSelectedOption.value +
	//             `'][data-swatches-option-` +
	//             inputName +
	//             `='` +
	//             inputValue +
	//             `'][data-enabled]`;

	//           break;
	//       }

	//       let optionsVariantSelector = variantSelector.querySelectorAll(selector);

	//       if (optionsVariantSelector.length == 0) {
	//         input.classList.add("disabled");
	//       } else {
	//         input.classList.remove("disabled");
	//       }
	//     });
	//   });
	// }

	disableOutOfStockVariants() {
		let variantSelect = this.getVariantSelector();

		let variantOptions = this.querySelectorAll(
			"[data-option] [data-swatch-input]"
		);
		let selectedOptions = {};

		variantOptions.forEach((option) => {
			if (option.checked) {
				let optionCategory = option
					.closest("[data-option]")
					.getAttribute("data-option");
				selectedOptions[optionCategory] = option.value
					.replaceAll(" ", "-")
					.replaceAll('"', "");
			}
		});

		if (Object.keys(selectedOptions).length === 0) {
			return; // Exit if no variants are selected
		}

		variantOptions.forEach((optionInput) => {
			let optionCategory = optionInput
				.closest("[data-option]")
				.getAttribute("data-option");
			let optionValue = optionInput.value
				.replaceAll(" ", "-")
				.replaceAll('"', "");
			let isEnabled = false;

			let selector = "option";
			for (let category in selectedOptions) {
				if (category !== optionCategory) {
					selector += `[data-swatches-option-${category}="${selectedOptions[category]}"]`;
				} else {
					selector += `[data-swatches-option-${category}="${optionValue}"]`;
				}
			}
			selector += "[data-enabled]";

			let isOptionEnabled = variantSelect.querySelector(selector);

			if (isOptionEnabled) {
				optionInput.classList.remove("disabled");
				optionInput.removeAttribute("disabled");
				optionInput.style.cursor = "pointer";
				isEnabled = true;
			} else {
				optionInput.classList.add("disabled");
				optionInput.setAttribute("disabled", true);
				optionInput.style.cursor = "not-allowed";
			}

			// Enable the input if any combination with its value is enabled
			this.querySelectorAll(
				`[data-option='${optionCategory}'] [data-swatch-input]`
			).forEach((input) => {
				let inputValue = input.value.replaceAll(" ", "-").replaceAll('"', "");
				let combinationSelector = "option";
				for (let cat in selectedOptions) {
					if (cat !== optionCategory) {
						combinationSelector += `[data-swatches-option-${cat}="${selectedOptions[cat]}"]`;
					} else {
						combinationSelector += `[data-swatches-option-${cat}="${inputValue}"]`;
					}
				}
				combinationSelector += "[data-enabled]";

				if (variantSelect.querySelector(combinationSelector)) {
					input.classList.remove("disabled");
					input.removeAttribute("disabled");
					input.style.cursor = "pointer";
				}
			});
		});
	}

	/**
	 * Selects the provided width value from the dropdown.
	 *
	 * The function searches for the dropdown with the name 'Width' and
	 * tries to set its value to the provided width value after extracting
	 * the actual width from a string format like 'Color / WidthValue'.
	 *
	 * @param {string} widthValue - A string containing the width value, typically in the format 'Color / WidthValue'.
	 * @returns {void}
	 */
	selectWidthOption(widthValue) {
		// Split the string based on the '/'
		const parts = widthValue.split("/");

		// The width should be the second part, but we need to trim any extra whitespace
		const width = parts[1] ? parts[1].trim() : "";

		// Get the dropdown element
		const dropdown = document.querySelector('[data-select][name="Width"]');

		// Check if dropdown exists
		if (dropdown) {
			// Iterate through the options to find the matching value
			for (const option of dropdown.options) {
				if (option.value === width) {
					dropdown.value = width;
					break;
				}
			}
		}
	}

	/**
	 * Update swatch inputs.
	 *
	 * @returns {undefined}
	 */
	updateSwatchValues() {}
}

customElements.define("component-swatch", swatchComponentNew);
window.onload = function () {};
